var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bg-whitepage-plan-alimentaires",
      staticStyle: { "margin-top": "-15px" }
    },
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modalEditionPlan",
            size: "lg",
            "hide-footer": "",
            "header-bg-variant": "gradient-bleu",
            "header-text-variant": "light"
          }
        },
        [
          _c("template", { slot: "modal-title" }, [
            _c("h3", { staticStyle: { color: "white" } }, [
              _vm._v("Édition de plan alimentaire")
            ])
          ]),
          _c(
            "template",
            { slot: "default" },
            [
              _c("EditionPlanAlimentaire", {
                attrs: { plan: _vm.currentPlan },
                on: {
                  "enregistrer-plan": _vm.planEnregistre,
                  "annuler-edition": _vm.fermerModalPlan
                }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          staticClass: "container-fluid bg-gradient-bleu",
          staticStyle: { "min-height": "60px", padding: "10px" }
        },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              staticStyle: {
                "background-color": "white",
                "font-weight": "bold",
                "font-size": "12px"
              },
              attrs: { alt: "Creer" },
              on: {
                click: function($event) {
                  return _vm.ajouterPlan()
                }
              }
            },
            [_vm._v("Créer un plan alimentaire")]
          )
        ]
      ),
      _c(
        "div",
        {
          key: _vm.key,
          staticClass: "container-fluid no-padding",
          staticStyle: { "min-height": "65vh", "background-color": "inherit" }
        },
        [
          _c("table", { staticClass: "table table-sm table-bordered" }, [
            _vm._m(0),
            _vm._m(1),
            _c(
              "tbody",
              _vm._l(_vm.plans, function(plan, iPlan) {
                return _c(
                  "tr",
                  {
                    key: iPlan,
                    staticStyle: { cursor: "pointer" },
                    attrs: { title: "Editer le plan alimentaire" },
                    on: {
                      click: function($event) {
                        return _vm.editerPlan(plan)
                      }
                    }
                  },
                  [
                    _c("td", [_vm._v(_vm._s(plan.nom))]),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(_vm._s(_vm.periode(plan.periodeId) || ""))
                    ]),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        _vm._s(
                          (plan.services &&
                            plan.services.filter(function(s) {
                              return s.composantes && s.composantes.length
                            }).length) ||
                            0
                        )
                      )
                    ]),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        _vm._s(
                          plan.services &&
                            plan.services.length &&
                            plan.services.reduce(function(t, s) {
                              return (
                                t +
                                ((s.composantes && s.composantes.length) || 0)
                              )
                            }, 0)
                        )
                      )
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "flex-center-space-between",
                        staticStyle: {
                          "text-align": "center",
                          "padding-top": "5px",
                          border: "none"
                        }
                      },
                      [
                        _c("i", {
                          staticClass: "fas fa-pen mr-2",
                          staticStyle: { margin: "2px auto" },
                          attrs: { title: "Modifier le plan alimentaire" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.modifierPlan(plan)
                            }
                          }
                        }),
                        _c("i", {
                          staticClass: "fas fa-trash rougeAgapInverse",
                          staticStyle: { margin: "2px auto" },
                          attrs: { title: "Supprimer le plan alimentaire" },
                          on: {
                            click: function($event) {
                              $event.stopPropagation()
                              return _vm.supprimerPlan(plan)
                            }
                          }
                        })
                      ]
                    )
                  ]
                )
              }),
              0
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("colgroup", [
      _c("col"),
      _c("col", { staticStyle: { width: "60px" } }),
      _c("col", { staticStyle: { width: "60px" } }),
      _c("col", { staticStyle: { width: "60px" } }),
      _c("col", { staticStyle: { width: "40px" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Nom du plan alimentaire")]),
        _c("th", [_vm._v("Période")]),
        _c("th", [_vm._v("Nombre de services")]),
        _c("th", [_vm._v("Nombre de composantes")]),
        _c("th")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }